import { DOMUtils } from '../../../../utils/dom'

export class ComScore {
    /**
     * Initialize ComScore in FEM
     */
    public init(account: string): void {
        let _comscore: any // tslint:disable-line
        _comscore = _comscore || [] // tslint:disable-line
        _comscore.push({
            c1: '2',
            c2: account
        })

        DOMUtils.loadScript(`//sb.scorecardresearch.com/beacon.js`)
    }
}
